import { render, staticRenderFns } from "./faqModel.vue?vue&type=template&id=6560b63e&scoped=true&lang=pug&"
import script from "./faqModel.vue?vue&type=script&lang=js&"
export * from "./faqModel.vue?vue&type=script&lang=js&"
import style0 from "./faqModel.vue?vue&type=style&index=0&id=6560b63e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6560b63e",
  null
  
)

export default component.exports